import PropTypes from 'prop-types'

/**
 * PageHeader - Consistent header for all pages
 *
 * Provides unified styling for:
 * - Page title
 * - Optional subtitle/breadcrumb
 * - Action buttons (right-aligned)
 */
export default function PageHeader({
  title,
  subtitle,
  children,
  className = ''
}) {
  return (
    <div className={`mb-6 ${className}`}>
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h1 className="text-2xl font-bold text-slate-900 truncate">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-sm text-slate-500">
              {subtitle}
            </p>
          )}
        </div>
        {children && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {children}
          </div>
        )}
      </div>
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
}
